<template>
  <el-dialog :title="$t('ExcelConfig.Title')" :visible.sync="dialogVisible" width="600px" :before-close="hide"
    destroy-on-close>
    <el-form ref="form" :model="form" :rules="rules" label-position="left">
      <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.country')" prop="country">
        <BjSelectLov v-model="form.country" :option-list="countryList" />
      </el-form-item>
    </el-form>
    <p>{{ $t('ExcelConfig.Import') }}</p>
    <div class="text">
      1.{{ $t('ExcelConfig.AfterDownload') }}<br />
      2.{{ $t('ExcelConfig.ImportExcel') }}
      <el-button type="primary" @click="onDownload">{{ $t('ExcelConfig.Download') }}</el-button><br />
      3.{{ $t('ExcelConfig.MustHave') }}<br />
      4.{{ $t('ExcelConfig.Supports') }}<br />
    </div>
    <div>
      <BjImportFile ref="BjImportFile" accept=".xls,.xlsx" :limit-size="128 * 1024" auto-upload @importFile="importFile">
        <template #top> </template>
        <template slot="default"> {{ $t('ExcelConfig.maximum') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" :disabled="!form.country || !tableData.length" @click="confirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { settingApi, importApi, thirdApi } from '@/api';
import { downloadBlob, getEnvGlobalConfig } from '@/utils/index';
const DEFAULT_BUCKET_NAME = getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME');
export default {
props: {
  countryList: {
    type: Array,
    require: true,
    default: () => []
  }
},
  data() {
    return {
      form: {
        country: null
      },
      rules: {
        code: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      dialogVisible: false,
      file: null,
      tableData: [], // 存放上传的excel文件的数据
    };
  },
  mounted() {},
  methods: {

    show() {
      this.file = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    onDownload() {
      const templatedCode = 'STHI.THIRD_ADDR_IMPORT';
      importApi.getImportTemplateHeaders({
        templateCode: templatedCode,
        size: 1,
        page: 0,
        total: 1,
        pageSize: 1,
        currentPage: 0
      }).then(res => {
        settingApi
          .downloadFileByUrl({
            bucketName: DEFAULT_BUCKET_NAME,
            url: res.content[0].templateUrl,
          })
          .then(resp => {
            downloadBlob(resp, res.content[0].templateFileName);
          });
      });
    },
    importFile(file) {
      this.tableData = [];
      const _this = this;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = function () {
        const buffer = reader.result;
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = '';
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require('xlsx');
        const wb = XLSX.read(binary, {
          type: 'binary',
        });
        const outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        for (const item of Object.values(outData)) {
          if (item['State'] && item['Suburb'] && item['Postcode']) {
            const obj = {
              'postcode': item['Postcode'],
              'state': item['State'],
              'suburb': item['Suburb'],
              'label': item['Label'],
              'labelsub': item['LabelSub'],
              'zone': item['Zone']
            };
            _this.tableData.push(obj);
          } else {
            _this.msgError(_this.$t('WarehouseManagement.form.msgErrorText'));
            return;
          }
        }
      };
    },
    confirm() {
      if (!this.tableData.length || !this.form.country) return;
      const API_DATA = {
        country: this.form.country,
        huntCodes: this.tableData
      };
        thirdApi.bulkImportPostCode(API_DATA).then((res) => {
          if (!res.failed) {
            this.$message({
              message: this.$t('toast.operationSuccessText'),
              type: 'success',
              duration: 5000,
            });
            this.hide();
            setTimeout(() => {
              this.$emit('submit');
            }, 1000);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
